// 05/24/2024---Hassnain Ali
import { useRef } from "react";
import { Image } from "react-bootstrap";
import { Modal, Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import { format } from "date-fns";

import avatarImage from "./../../assets/images/avatar.svg";

function NoteAddModal({ show, handleClose, data, module }) {
  const node_env = process.env.NODE_ENV;
  const media_origin = node_env === "production" ? "" : process.env.REACT_APP_BACKEND_URL;
  const descriptionRef = useRef(null);

  //    Sending data to the parent component for posting to the server
  // const sendData = (category) => {
  //   if (descriptionRef.current.value !== "" && category !== "") {
  //     handleFormSubmission(category, descriptionRef.current.value);
  //   }
  // };
  const handleProfilePic = (note) => {
    let profilePicUrl;

    try {
      profilePicUrl = note.created_by?.bp_attorneystaff_userprofile?.profile_pic_29p
        ? media_origin + note.created_by.bp_attorneystaff_userprofile.profile_pic_29p
        : avatarImage;
    } catch (error) {
      profilePicUrl = avatarImage;
    }
    return profilePicUrl;
  };
  return (
    <Modal show={show} onHide={handleClose} centered dialogClassName="m-900max">
      <Modal.Header className="text-center">
        <Modal.Title className="mx-auto" id="individual_notes_modal_title">
          Add {module} Notes
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="panel-popups-body">
        <div className="w-100">
          <div className="d-flex justify-content-start" id="notes-form-panel">
            {/* <div className="footer-line ss-m-bottom">
              <Button variant="primary" className="ms-0 rounded-0" onClick={() => sendData("Critical")}>
                New <br />
                Critical<br />
                Note
              </Button>
            </div> */}
            <Form.Control
              as="textarea"
              id="note_description_panel"
              style={{
                marginLeft: "0px !important",
                marginRight: "0px !important",
              }}
              required
              name="description"
              placeholder="Case Note:.."
              ref={descriptionRef}
            />
            {/* <div className="footer-line">
              <Button variant="primary" className="ms-2 rounded-0" onClick={() => sendData("Update Case Status")}>
                Update<br />
                Case<br />
                Status
              </Button>
            </div> */}
          </div>
          {/* Checking if the page matches the pannel */}
          {/* <div id="todo-form-panel">
            <Form.Control as="textarea" id="todo-note" hidden name="note" />
            <div className="footer-line ss-m-bottom">
              <div className="row align-items-center">
                <div className="col-lg-8 col-md-6 col-sm-12 d-flex align-items-center text-nowrap">
                  <p className=' m-r-5'>To-Do for</p>
                  <input className='m-r-5' type='checkbox'></input>
                 <p className=' m-r-5'>due in</p>
                  <Form.Control style={{marginRight: "5px"}} as="select" className="right footer-select w-50 m-r-5 form-select" name="due_date">
                    <option value="Now">Now</option>
                    <option value="1 day">1 day</option>
                    <option value="2 days">2 days</option>
                    <option value="3 days">3 days</option>
                    <option value="4 days">4 days</option>
                    <option value="5 days">5 days</option>
                    <option value="6 days">6 days</option>
                    <option value="1 week">1 week</option>
                    <option value="2 weeks">2 weeks</option>
                    <option value="1 month">1 month</option>
                    <option value="2 months">2 months</option>
                    <option value="6 months">6 months</option>
                  </Form.Control>
                  <Button className="btn btn-primary rounded-0"  type="button">
                    <span className="fw-bold pe-2 text-gold">+</span>To-Do
                  </Button>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 d-flex align-items-center justify-content-end">
                  <Form.Control style={{marginRight: "5px"}} as="select" name='category' id="note_category_panel" className="right footer-select w-50 m-r-5 form-select" ref={noteSelectRef}>
                   
                    {pages && pages.length > 0 ? 
                    (
                        pages.map((page,index) => (
                          module === page.name && <option value={page.name} key={index}>{page.name}</option>
                         ))
                    ):<option>No Option</option>
                     }
                  </Form.Control>
                  <Button className="btn btn-primary rounded-0" type="button" onClick={() => sendData(noteSelectRef.current.value)}>
                    <span className="fw-bold pe-2 text-gold">+</span>Note
                  </Button>
                </div>
              </div>
            </div>
          </div> */}
          <nav className="m-t-5">
            {" "}
            {/* this nav is important -> binds with the notatable class in theme.css (idk why it was done this way) */}
            <div className="notetable">
              <div className="custom-tab">
                <div
                  className="tab-pane"
                  id="custom-nav-todo"
                  role="tabpanel"
                  aria-labelledby="custom-nav-todo-tab"
                >
                  <div className="table-responsive table--no-card">
                    <Table className="table table-borderless table-striped table-earning">
                      <thead>
                        <tr>
                          <th className="INS-width-1px text-uppercase" />
                          <th className="text-uppercase">Date</th>
                          <th className="text-uppercase">Time</th>
                          <th className="td-autosize text-uppercase">User</th>
                          <th className="text-uppercase">Note</th>
                          <th className="text-uppercase">Category</th>
                          <th className="text-uppercase" />
                        </tr>
                      </thead>
                      <tbody id="table-body-cat-notes">
                        {data && data.length > 0 ? (
                          data.map((note, index) => (
                            <tr className={`${note.entity_type}${note.record_id}`} key={note.id}>
                              <td className="td-autosize width-36">{index + 1}</td>
                              <td className="td-autosize">
                                {" "}
                                {format(note.created_at, "MMMM dd, yyyy")}
                              </td>
                              <td className="td-autosize"> {format(note.created_at, "hh:mm a")}</td>
                              <td className="td-autosize d-flex align-items-center">
                                <span className="ic ic-avatar ic-29 has-avatar-icon has-cover-img">
                                  <Image src={handleProfilePic(note)} alt="" className="" />
                                </span>
                                <span className="ms-2 text-black whitespace-nowrap">
                                  {note.created_by.first_name} {note.created_by.last_name}
                                </span>
                              </td>
                              <td className="client_page_note_row INS-color-black">
                                {note.description}
                              </td>
                              <td className="td-autosize">
                                {note.category?.name ? note.category.name : module}
                              </td>
                              <td className="td-autosize hover-button">
                                <Button variant="secondary" className="edit-notes-btn">
                                  Edit
                                </Button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" className="text-center">
                              No data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" className="INS-float-margin" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="success" type="submit" form="addDefendantInsuranceForm">
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default NoteAddModal;
